import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BlackBaudInfo {
  correlationIdSearch: string;
  fromDateSearch: string;
  toDateSearch: string;
  typeSearch: string;
  participantIdSearch: number;
  statusSearch: string;
  rowsPerPage: number;
  page: number;
}

const initialState: BlackBaudInfo = {
  correlationIdSearch: "",
  fromDateSearch: "",
  toDateSearch: "",
  typeSearch: "All",
  participantIdSearch: 0,
  statusSearch: "All",
  rowsPerPage: 5,
  page: 0,
};

const createBlackBaudLogSlice = createSlice({
  name: "blackBaudLog",
  initialState,
  reducers: {
    setCreateBlackBaudLog: (
      state,
      action: PayloadAction<Partial<BlackBaudInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeBlackBaudLog: () => initialState,
  },
});

export const { setCreateBlackBaudLog, removeBlackBaudLog } =
  createBlackBaudLogSlice.actions;
export default createBlackBaudLogSlice.reducer;
